import { clsx } from 'clsx';
import classes from './Pagehead.module.css.js';
import { jsx } from 'react/jsx-runtime';

const Pagehead = ({
  as: BaseComponent = 'div',
  className,
  ...rest
}) => {
  return /*#__PURE__*/jsx(BaseComponent, {
    className: clsx(classes.Pagehead, className),
    ...rest
  });
};
Pagehead.displayName = "Pagehead";

export { Pagehead as default };
